import React from "react"

import {
    DataCell,
    Icon,
} from "@bdfx/mergado-ui-kit"

import {SortByType} from "../types";
import trans, {isTrans} from "trans";

interface Props {
    className?: string
    sortBy : SortByType
    table: string
    column : string
    title?: string
    isNumeric?: boolean
    maxWidth?: number
    handleSortBy : Function
}

export const ProductsTable = 'products'
export const ProductElementsTable = 'product_elements'
export const ImagesTable = 'images'
export const ImageValidationsTable = 'image_validations'
export const ImageWatermarksTable = 'image_watermarks'
export const ImageQualityTable = 'image_quality'
export const NoTable = ''

const SortIconColor = '#e1f6f6'

const DataCellSortable = (props: Props) => {
    const {sortBy, column, title, table, isNumeric, maxWidth, className} = props
    const headerTitle = (title && isTrans(title)) ? trans(title) : (isTrans('element_'+column) ? trans('element_'+column) : column)
    const updatedClassName = `centered clickable ${className}`
    const iconSize = 14

    const sortAscIcon = <span onClick={() => props.handleSortBy({table: table, column: column, direction: 'desc'})}>        
        <Icon type={isNumeric ? 'sort-numeric-asc' : 'sort-alpha-asc'} color={SortIconColor} style={{paddingLeft: '10px'}} size={iconSize} />
    </span>

    const sortDescIcon = <span  onClick={() => props.handleSortBy({table: table, column: column, direction: 'asc'})}>
        <Icon type={isNumeric ? 'sort-numeric-desc' : 'sort-alpha-desc'} color={SortIconColor} style={{paddingLeft: '10px'}} size={iconSize} />
    </span>

    const sortableIcon = <Icon type={'sort-amount-desc'} size={iconSize} color={SortIconColor} />
    const cancelSortIcon = <span onClick={() => props.handleSortBy({table: table, column: column, direction: null})}><Icon type={'close'} color={'#ffe7e7'} /></span>
    const customStyle = maxWidth ? {width: maxWidth+'%'} : {}

    if (sortBy && sortBy.column === column) {
        return <DataCell type="header" key={column} className={updatedClassName + ' header-cell-active'} style={customStyle}>
            {headerTitle} {sortBy.direction === 'asc' ? sortAscIcon : sortDescIcon} {cancelSortIcon}
        </DataCell>
    }

    return <DataCell type="header" key={column} className={updatedClassName} onClick={() => props.handleSortBy({ table: table, column: column, direction: 'asc' })}>
        {headerTitle} {sortableIcon}
    </DataCell>
}

export default DataCellSortable
